import { CopyOutlined } from '@ant-design/icons';
import { useAccess } from '@sitemax/smx-permission';

import { useModal } from 'hooks/useModal';
import { useAppDispatch } from 'utilities/hooks';
import { useAppSelector } from 'utilities/hooks';
import { copyDocument, refreshDocumentTreeLevels } from 'slices/documentsActions';
import { Category, Document } from 'interfaces/documents';

export const Copy = (
    rows: Document[],
    fetchData: () => void
) => {
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const { breadcrumbs } = useAppSelector((state) => state.documents);
    const isProjectDocument = breadcrumbs?.length > 0 ? breadcrumbs[breadcrumbs.length - 1].is_project_document : false;
    const canCreate = useAccess(isProjectDocument ? ['files.project.create'] : ['files.all.create']);

    const copyItem = async (destination: Category | null) => {
        // Has to be awaited as a whole: refreshing before the copies land would
        // just re-read the pre-copy state.
        await Promise.all(rows.map((item) => dispatch(copyDocument({
            id: item.id,
            category_id: destination?.id || null,
        }))));

        dispatch(refreshDocumentTreeLevels([destination?.id]));
        fetchData();
    };

    if (!canCreate) return null;

    return {
        key: 'Copy',
        label: 'Copy',
        onClick: () => {
            openModal('categoriesTreeModal', {
                title: 'Copy to...',
                submitLabel: 'Copy',
                cancelLabel: 'Cancel',
            }, {
                onSubmit: (value: Category | null) => {
                    copyItem(value);
                }
            });
        },
        icon: <CopyOutlined />,
        disabled: !rows.length,
    };
};